import React, { useState } from 'react'

import Loading from '../../component/Loading/Loading'
import ReadpointSelector from '../../readpoint/component/ReadpointSelector'
import AssetSelector from '../../component/Asset/AssetSelector'
import HttpRequest from '../../services/HttpRequest'

const request = new HttpRequest()

export const DevNewSensePage = () => {

  const [readpoint, setReadpoint] = useState(null)
  const [epc, setEpc] = useState(null)
  const [isLoading, setIsLoading] = useState(null)

  const doRequest = async () => {
    setIsLoading(true)
    const date = new Date(Date.now()).toISOString()
    const body = {
      values: epc.map(asset => {
        return asset.epc.value
      }),
      readpointId: readpoint,
      when: date
    }
    await request.post('/ton/v1/events', body)
    setIsLoading(false)
  }

  return (
    <React.Fragment>
      <ReadpointSelector setValue={a => setReadpoint(a)} />
      <label>Digite o EPC</label>
      <AssetSelector setValue={a => setEpc(a)} multiple={true}/>
      <button onClick={doRequest}>enviar</button>
      { isLoading ? <Loading /> : 'Preparado para enviar request' }
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/pages/Dev/DevNewSense.js